const Tooltip = ({
  text,
  children,
  className = "",
}) => {
  return (
    <div
      className={`relative inline-block group ${className}`}
    >
      <span
        className="
          invisible
          absolute
          bottom-full
          left-1/2
          -translate-x-1/2
          whitespace-nowrap
          rounded
          bg-[#333]
          px-2
          py-1
          text-white
          opacity-0
          transition-opacity
          duration-200
          group-hover:visible
          group-hover:opacity-100
          z-50
        "
      >
        {text}
      </span>

      {children}
    </div>
  );
};

export default Tooltip;